import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import FromApp from '../../../../components/ResourceSelector/DrivePicker/FromApp';
import Utils from '../../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		galleryInfos,
		driveList,
	} = state;
	const { breadcrumbs } = driveList;

	return {
		driveList,
		privateDirId: Utils.getPrivateDirId(driveList, galleryInfos.config),
		sharedDirId: Utils.getSharedDirId(driveList, galleryInfos.config),
		sourcesDirId: Utils.getSourcesDirId(driveList, galleryInfos.config),
		applicationId: galleryInfos.config.applicationGallery,
		currentDriveId: breadcrumbs.length === 0
			? undefined
			: breadcrumbs[breadcrumbs.length - 1].id,
	};
};

export default connect(mapStateToProps)(FromApp);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ResourceSelector/DrivePicker/FromApp/index.tsx